import { BookMarked, Box as BoxIcon, Frame, Lamp, Trophy, Star, Package, Feather } from "lucide-react";

const t = (key, label, extra = {}) => ({ key, label, kind: "text", ...extra });
const ta = (key, label) => ({ key, label, kind: "textarea" });

const ITEMS = {
  timeline: [t("period", "Période"), t("title", "Titre / poste"), t("subtitle", "Structure / école"), t("place", "Lieu"), ta("description", "Description")],
  cards: [t("title", "Titre"), t("subtitle", "Sous-titre"), ta("description", "Description")],
  gallery: [{ key: "image", label: "Image", kind: "image" }, t("title", "Titre"), t("caption", "Légende")],
  films: [t("title", "Titre"), t("year", "Année"), t("role", "Rôle"), t("duration", "Durée"), t("genre", "Genre"), ta("synopsis", "Synopsis"),
    { key: "thumbnail", label: "Miniature", kind: "image" }, { key: "video", label: "Lien YouTube ou Vimeo", kind: "text" }],
};

const list = (key, label, fields, itemLabel) => ({ key, label, kind: "list", fields, itemLabel });

// Champs modifiables pour chaque type de rubrique
export const SCHEMAS = {
  about: [{ key: "portrait", label: "Portrait", kind: "image" }, { key: "paragraphs", label: "Paragraphes", kind: "strings", multiline: true },
    t("quote", "Citation"), list("facts", "Chiffres clés", [t("label", "Libellé"), t("value", "Valeur")], "label")],
  films: [list("items", "Films & projets", ITEMS.films, "title")],
  gallery: [list("items", "Images", ITEMS.gallery, "title")],
  timeline: [list("items", "Étapes", ITEMS.timeline, "title")],
  cards: [list("items", "Éléments", ITEMS.cards, "title")],
  skills: [list("categories", "Catégories", [t("name", "Catégorie"), list("items", "Compétences", [t("name", "Nom"), { key: "level", label: "Niveau (0-100)", kind: "number" }], "name")], "name")],
  languages: [list("spoken", "Langues", [t("name", "Langue"), t("level", "Niveau"), { key: "value", label: "Jauge (0-100)", kind: "number" }], "name"),
    list("countries", "Pays visités", [t("name", "Pays"), t("year", "Année"), t("note", "Note")], "name")],
  music: [ta("intro", "Introduction"),
    list("records", "Disques", [{ key: "spotify", label: "Rechercher sur Spotify", kind: "spotify" }, t("album", "Album"), t("artist", "Artiste"), t("year", "Année"), { key: "color", label: "Couleur de la pochette", kind: "color" }], "album"),
    { key: "genres", label: "Genres", kind: "strings" }, { key: "artists", label: "Inspirations", kind: "strings" }],
  contact: [ta("intro", "Texte d'introduction")],
  credits: [ta("aiNote", "Mention « fait avec l'IA »"), ta("intro", "Texte d'introduction"),
    list("people", "Personnes à créditer", [t("name", "Nom"), t("role", "Rôle (ex. Idée originale)"), ta("description", "Quelques mots"),
      { key: "photo", label: "Photo (facultatif)", kind: "image" }, list("links", "Réseaux / LinkedIn", [t("label", "Nom (ex. LinkedIn)"), t("url", "Lien")], "label")], "name")],
  text: [{ key: "paragraphs", label: "Paragraphes", kind: "strings", multiline: true }],
};

export const PROFILE_SCHEMA = [t("firstName", "Prénom"), t("lastName", "Nom"), t("role", "Métier(s)"), t("location", "Ville"), ta("tagline", "Phrase d'accroche"),
  t("email", "E-mail"), t("phone", "Téléphone"), t("availability", "Disponibilité"), list("socials", "Réseaux", [t("label", "Nom"), t("url", "Lien")], "label")];

export const TYPE_LABELS = {
  text: "Texte libre", timeline: "Parcours / chronologie", cards: "Cartes", gallery: "Galerie d'images", films: "Vidéos",
  about: "Présentation", skills: "Compétences", languages: "Langues & pays", music: "Musique", contact: "Contact", credits: "Crédits",
};
export const CUSTOM_TYPES = ["text", "timeline", "cards", "gallery", "films"];

// Objets disponibles pour les nouvelles rubriques
export const MODELS = {
  notebook: { label: "Carnet", icon: BookMarked },
  box: { label: "Boîte à souvenirs", icon: Package },
  frame: { label: "Cadre sur chevalet", icon: Frame },
  lamp: { label: "Lanterne", icon: Lamp },
  trophy: { label: "Trophée", icon: Trophy },
  star: { label: "Étoile lumineuse", icon: Star },
  quill: { label: "Plume & encrier", icon: Feather },
  chest: { label: "Petite malle", icon: BoxIcon },
};

// Emplacements libres dans la chambre pour les rubriques ajoutées
export const SLOTS = [[-1.9, 0, -1.3], [3.3, 0, 3.3], [-2.3, 0, 3.4], [0.1, 0, 3.7], [2.25, 0, -0.85], [-2.55, 0, -2.2]];

export const blankFrom = (fields) => Object.fromEntries(fields.map((f) => [f.key, f.kind === "list" || f.kind === "strings" ? [] : f.kind === "number" ? 50 : f.kind === "color" ? "#C85A32" : ""]));

export const blankData = (type) => blankFrom(SCHEMAS[type] || []);
